import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  const results = ["Menos sensación de 'abdomen duro'", 'Menos incomodidad al final del día', 'Más claridad sobre qué te cae pesado', 'Menos ansiedad al comer porque hay un plan'];
  return <section className="py-20 px-4 bg-terracotta text-white" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center" data-id="element-110">
        <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-111">
          Qué cambia en 7 días
        </h2>

        <div className="grid sm:grid-cols-2 gap-6 mb-12" data-id="element-112">
          {results.map((result, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-113">
              <p className="text-lg font-medium" data-id="element-114">{result}</p>
            </motion.div>)}
        </div>

        <p className="text-2xl font-serif italic opacity-90" data-id="element-115">
          Y sobre todo: vuelves a sentir que tu cuerpo te escucha.
        </p>
      </div>
    </section>;
}